import React, { useState, createContext, useMemo } from 'react';

const VendorsContext = createContext();

const VendorsProvider = props => {
  const [vendors, setVendors] = useState([]);

  // Memoize the context value
  const contextValue = useMemo(() => [vendors, setVendors], [vendors]);
  // eslint-disable-next-line
  return <VendorsContext.Provider value={contextValue}>{props.children}</VendorsContext.Provider>;
};

export { VendorsContext, VendorsProvider };
